<template>
  <div class="register-wrapper">
    <img
      class="banner-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/48df60ce25448680262d65d172603200.png"
      alt=""
    />
    <div class="login-container">
      <div class="input-item">
        <div class="area-code item-left" @click="bindShowArea"
          >+{{ areaCode
          }}<!-- <span
                        class="iconfont icon-xiala"></span> --></div
        >
        <input
          class="input"
          type="number"
          placeholder="请输入手机号码"
          maxlength="20"
          v-model="phone"
          @blur="checkPhone(phone)"
        />
      </div>
      <div class="input-item">
        <!-- <div class="item-left block iconfont icon-weijiesuo"></div> -->
        <input
          class="input"
          type="number"
          placeholder="输入验证码"
          @blur="checkCode(code)"
          maxlength="4"
          v-model="code"
        />
        <div
          class="send-code"
          :class="{ 'send-code-disabled': codeTime }"
          @click="bindSendCode"
        >
          {{ codeTime ? '已发送 ' + codeTime + 'S' : '获取验证码' }}
        </div>
      </div>
      <div class="register-btn" @click="bindLogin">登录</div>
      <div class="agrement">
        <div class="check" @click="bindToggleAgree"
          ><span class="iconfont icon-gou" v-show="agree"></span
        ></div>
        <div class="agrement-text"
          >我已阅读并同意<span class="agrement-bold"
            ><span @click="bindToPrivacyAgreement">《用户隐私协议》</span
            ><span @click="bindToAgreement">《用户服务协议》</span
            ><span @click="bindToCourseAgreement">《课程服务协议》</span></span
          >
        </div>
      </div>
    </div>
    <van-popup v-model="showArea">
      <div class="index-content" @click.stop>
        <div class="close iconfont icon-cha" @click="bindClose"></div>
        <div class="index-top"> </div>
        <div class="index-container">
          <van-index-bar @select="bindSelect" :index-list="areaIndexList">
            <div v-for="(item, index) in areaData" :key="index">
              <van-index-anchor :index="item.alpha" />
              <div
                v-for="(item1, index1) in item.subItems"
                :key="index1"
                class="index-item"
                @click="bindClickItem(item1)"
                ><span class="item-code">+{{ item1.code }}</span>
                <span>{{ item1.name }}</span>
              </div>
            </div>
          </van-index-bar>
        </div>
      </div>
    </van-popup>
    <!-- <van-overlay :show="showArea" @click="showArea = false">
            <div class="index-content" @click.stop>
                <div class="close iconfont icon-cha"></div>
                <div class="index-top"> </div>
                <div class="index-container">
                    <van-index-bar @select="bindSelect">
                        <div v-for="(item, index) in areaData" :key="index">
                            <van-index-anchor :index="item.alpha" />
                            <div v-for="(item1, index1) in item.subItems" :key="index1"><span>+{{ item1.code }}</span>
                                <span>{{ item1.name }}</span></div>
                        </div>
                    </van-index-bar>
                </div>
            </div>
        </van-overlay> -->
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      areaData: [],
      showArea: false,
      phone: '',
      code: '',
      areaCode: 86,
      disabledSend: false,
      agree: false,
      codeTime: ''
    }
  },
  watch: {
    code(val) {
      if (val.length > 4) {
        this.code = val.slice(0, 4)
      }
    }
  },
  computed: {
    areaIndexList() {
      if (this.areaData.length) {
        return this.areaData.map((item) => {
          return item.alpha
        })
      } else {
        return []
      }
    }
  },
  created() {
    this.getAreaData()
  },
  methods: {
    bindClose() {
      this.showArea = false
    },
    bindClickItem(item) {
      this.areaCode = item.code
      this.bindClose()
    },
    async getAreaData() {
      let res = await this.$http.getApp('areaCode', {}).catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.areaData = this.filterAreaData(res.data)
        }
      }
    },
    //将后端给的arealist转成前端能用的
    filterAreaData(list) {
      let areaObj = {}
      list.map((item) => {
        let letter = (item.namePinyin && item.namePinyin.slice(0, 1)) || ''
        if (areaObj[letter]) {
          areaObj[letter].push(item)
        } else {
          areaObj[letter] = []
          areaObj[letter].push(item)
        }
      })
      let res = []
      for (var key in areaObj) {
        let obj = {}
        obj.alpha = key.toUpperCase()
        obj.subItems = areaObj[key]
        res.push(obj)
      }
      return res
    },
    bindSelect(index) {
      console.log(index)
    },
    bindShowArea() {
      this.showArea = true
    },
    bindSendCode() {
      if (this.disabledSend) {
        return
      }
      if (!this.checkPhone(this.phone)) {
        this.$toast('请检查手机号码长度')
        return
      }
      if (!this.agree) {
        this.$toast('请勾选隐私协议')
        return
      }
      this.disabledSend = true
      let params = {
        phone: this.phone,
        areaCode: this.areaCode
      }
      this.$http
        .postBaseApp('sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.$toast('发送成功')
            this.codeInterval()
          } else {
            this.disabledSend = false
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.disabledSend = false
        })
    },
    bindToAgreement() {
      this.$router.push('/agreement')
    },
    bindToPrivacyAgreement() {
      this.$router.push('/privacy-agreement')
    },
    bindToCourseAgreement() {
      this.$router.push('/join-camp-question-v2/course-agreement')
    },
    codeInterval() {
      this.codeTime = 60
      this.timer = setInterval(() => {
        this.codeTime--
        if (this.codeTime <= 0) {
          this.disabledSend = false
          clearInterval(this.timer)
          // this.codeTime = 0;
        }
      }, 1000)
    },
    checkParams() {
      let res = this.checkPhone(this.phone) && this.checkCode(this.code)
      return res
    },
    checkPhone(phone) {
      if (!phone.length) {
        this.$toast('请输入电话号码')
        return false
      }
      return true
    },
    checkCode(code) {
      code = code.trim()
      if (!code) {
        this.$toast('请输入验证码')
      }
      return code
    },
    bindToggleAgree() {
      this.agree = !this.agree
    },
    async bindLogin() {
      if (!this.agree) {
        this.$toast('请勾选隐私协议')
        return
      }
      if (!this.checkParams()) {
        return
      }
      let params = {
        phone: this.phone,
        identify_code: this.code,
        areaCode: this.areaCode
      }
      let res = await this.$http
        .postBaseApp('que/Questionnaire/registerQueUser', params)
        .catch((err) => {
          console.log(err)
        })
      if (res) {
        res = res.data
        if (res.code === 200) {
          this.$toast('成功')
          let expires = new Date(new Date() * 1 + 1000 * 60 * 20) //设置20分钟过期
          Cookies.set('join-camp-token', res.data, { expires: expires })
          this.autoJump(res.data)
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.msg
          })
        }
      }
    },
    /* 如果参数携带backUrl则拼接token并跳转到backUrl */
    autoJump(token) {
      let backUrl = this.$route.query?.backUrl
      if (backUrl) {
        backUrl = decodeURIComponent(backUrl)
        backUrl =
          backUrl + (backUrl.includes('?') ? '&' : '?') + 'token=' + token
        location.replace(backUrl)
      } else {
        this.$http.appBack()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.register-wrapper {
  .banner-image {
    width: 100%;
    height: 242px;
    background-color: rgb(249, 249, 249);
  }

  .login-container {
    background-color: #fff;
    position: relative;
    z-index: 1;
    margin-top: -13px;
    padding: 34px 32px;
    border-radius: 16px 16px 0px 0px;
  }

  .input-item {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #e7e7e7;
    padding: 20px 0px;
    margin-bottom: 12px;

    .area-code {
      position: relative;
      color: #7e7e7e;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      margin-right: 20px;

      .iconfont {
        margin-left: 10px;
      }
    }

    .block {
      color: rgba(0, 0, 0, 0.3);
    }

    .input {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      border: none;
      outline: none;
      background: transparent;
      height: 20px;
    }

    .input::placeholder {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.3);
      line-height: 20px;
    }

    .send-code {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 12px;
      color: #fe0932;
      white-space: nowrap;
      margin-left: 10px;
    }

    .send-code-disabled {
      color: rgba(0, 0, 0, 0.3);
    }
  }

  .register-btn {
    height: 48px;
    line-height: 48px;
    background: #ff2c4c;
    border-radius: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    margin-top: 42px;
    margin-bottom: 24px;
  }

  .agrement {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .check {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid rgba(221, 221, 221, 1);
      box-sizing: border-box;
      margin-right: 9px;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        font-weight: 600;
        font-size: 16px;
        color: #ff2c4c;
      }
    }

    .agrement-text {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: #878787;
      line-height: 16px;

      .agrement-bold {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 600;
      }
    }
  }
}

.index-content {
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .close {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 1px;
    left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
  }

  .index-top {
    height: 40px;
  }

  .index-container {
    flex: 1;
    flex-shrink: 0;
    overflow: scroll;

    .index-item {
      height: 30px;
      padding: 0px 16px;
      display: flex;
      align-items: center;

      .item-code {
        width: 100px;
        margin-right: 20px;
      }
    }
  }
}
</style>
